import { render } from "./AtsiriMuseum.vue?vue&type=template&id=5564b142&scoped=true&ts=true"
import script from "./AtsiriMuseum.vue?vue&type=script&lang=ts"
export * from "./AtsiriMuseum.vue?vue&type=script&lang=ts"

import "./AtsiriMuseum.vue?vue&type=style&index=0&id=5564b142&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenz\\atsiriBookingApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5564b142"]])

export default __exports__